import { render, staticRenderFns } from "./leftNav.vue?vue&type=template&id=5b4e22f6&scoped=true&"
import script from "./leftNav.vue?vue&type=script&lang=js&"
export * from "./leftNav.vue?vue&type=script&lang=js&"
import style0 from "./leftNav.vue?vue&type=style&index=0&id=5b4e22f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4e22f6",
  null
  
)

export default component.exports